import React from 'react'

function Table({data}) {
  return (
    <table border={"1px solid #9e9e9e"}>
      <thead>
        <tr>
          <td colSpan={2} className="table-bg-color"></td>
          <th>0데이터 제외(상,하위 10%포함)</th>
          <th>상,하위 10%제외</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="3" className="table-bg-color">
            이벤트 발생 건수
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.events?.stats1?.total_table ?? 0} 건
          </td>
          <td className="align-right">
            {data?.events?.stats2?.total_table ?? 0} 건
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.events?.stats1?.max_table ?? 0} 건
          </td>
          <td className="align-right">
            {data?.events?.stats2?.max_table ?? 0} 건
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.events?.stats1?.average_table ?? 0} 건
          </td>
          <td className="align-right">
            {data?.events?.stats2?.average_table ?? 0} 건
          </td>
        </tr>
        <tr>
          <td rowspan="3" className="table-bg-color">
            주행 건수
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.trips?.stats1?.total_table ?? 0} 건
          </td>
          <td className="align-right">
            {data?.trips?.stats2?.total_table ?? 0} 건
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.trips?.stats1?.max_table ?? 0} 건
          </td>
          <td className="align-right">
            {data?.trips?.stats2?.max_table ?? 0} 건
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.trips?.stats1?.average_table ?? 0} 건
          </td>
          <td className="align-right">
            {data?.trips?.stats2?.average_table ?? 0} 건
          </td>
        </tr>
        <tr>
          <td rowspan="3" className="table-bg-color">
            저장 영상 수
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.content_count?.stats1?.total_table ?? 0} 개
          </td>
          <td className="align-right">
            {data?.content_count?.stats2?.total_table ?? 0} 개
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.content_count?.stats1?.max_table ?? 0} 개
          </td>
          <td className="align-right">
            {data?.content_count?.stats2?.max_table ?? 0} 개
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.content_count?.stats1?.average_table ?? 0} 개
          </td>
          <td className="align-right">
            {data?.content_count?.stats2?.average_table ?? 0} 개
          </td>
        </tr>
        <tr>
          <td rowspan="3" className="table-bg-color">
            저장 영상 용량(GB)
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.content_size?.stats1?.total_table ?? 0} GB
          </td>
          <td className="align-right">
            {data?.content_size?.stats2?.total_table ?? 0} GB
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.content_size?.stats1?.max_table ?? 0} GB
          </td>
          <td className="align-right">
            {data?.content_size?.stats2?.max_table ?? 0} GB
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.content_size?.stats1?.average_table ?? 0} GB
          </td>
          <td className="align-right">
            {data?.content_size?.stats2?.average_table ?? 0} GB
          </td>
        </tr>
        <tr>
          <td rowspan="3" className="table-bg-color">
            라이브 뷰 시간(분)
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.liveview_time?.stats1?.total_table ?? 0} 분
          </td>
          <td className="align-right">
            {data?.liveview_time?.stats2?.total_table ?? 0} 분
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.liveview_time?.stats1?.max_table ?? 0} 분
          </td>
          <td className="align-right">
            {data?.liveview_time?.stats2?.max_table ?? 0} 분
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.liveview_time?.stats1?.average_table ?? 0} 분
          </td>
          <td className="align-right">
            {data?.liveview_time?.stats2?.average_table ?? 0} 분
          </td>
        </tr>
        <tr>
          <td rowspan="3" className="table-bg-color">
            라이브 뷰 횟수
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.liveview_count?.stats1?.total_table ?? 0} 회
          </td>
          <td className="align-right">
            {data?.liveview_count?.stats2?.total_table ?? 0} 회
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.liveview_count?.stats1?.max_table ?? 0} 회
          </td>
          <td className="align-right">
            {data?.liveview_count?.stats2?.max_table ?? 0} 회
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.liveview_count?.stats1?.average_table ?? 0} 회
          </td>
          <td className="align-right">
            {data?.liveview_count?.stats2?.average_table ?? 0} 회
          </td>
        </tr>
        <tr>
          <td rowspan="3" className="table-bg-color">
            저장 영상 재생 횟수
          </td>
          <td className="table-bg-color">전체</td>
          <td className="align-right">
            {data?.cloud_play?.stats1?.total_table ?? 0} 회
          </td>
          <td className="align-right">
            {data?.cloud_play?.stats2?.total_table ?? 0} 회
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">최대(1단말/1일)</td>
          <td className="align-right">
            {data?.cloud_play?.stats1?.max_table ?? 0} 회
          </td>
          <td className="align-right">
            {data?.cloud_play?.stats2?.max_table ?? 0} 회
          </td>
        </tr>
        <tr>
          <td className="table-bg-color">평균(1단말/1일)</td>
          <td className="align-right">
            {data?.cloud_play?.stats1?.average_table ?? 0} 회
          </td>
          <td className="align-right">
            {data?.cloud_play?.stats2?.average_table ?? 0} 회
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default Table